// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"author-component_uk-open__acnZQ","grecaptcha-badge":"author-component_grecaptcha-badge__a8OTO","author":"author-component_author__1lf8c","meta":"author-component_meta__X1CKJ","name":"author-component_name__84OJj","image":"author-component_image__hM2kr","description":"author-component_description__kGnRL","about":"author-component_about__RWSyZ"};
    if(module.hot) {
      // 1793877041855
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  